








































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { outgoingInvoiceApi } from '@/services/st-api';
import { UserStore } from '@/store/user-module';
import { notifySuccess } from '@/utlitities/notifications';
import { OutgoingInvoiceSettingsEditModel } from '@/services/api/nswag/stapiclient_generated';
import StSettingsSeparator from '@/components/basic/Form/StSettingsSeparator.vue';

@Component({
  components: { StSettingsSeparator },
})
export default class AccountSettingsInvoice extends Vue {
  @Prop() isModal!: boolean;
  @Prop() useEmailSending!: boolean;
  loading: boolean = false;
  loadingOverlay: boolean = false;
  editModel: OutgoingInvoiceSettingsEditModel = OutgoingInvoiceSettingsEditModel.fromJS({});
  logo: string = '';
  localCurrentIncrementValue = 0;

  async mounted() {
    try {
      this.loadingOverlay = true;
      this.$emit('loadStart');
      await this.loadData();
    } finally {
      this.loadingOverlay = false;
      this.$emit('loadEnd');
    }
  }

  async loadData() {
    this.editModel = await outgoingInvoiceApi.getSettingsEditModel();
    await this.$nextTick();
    await this.loadCurrentLocalIncrementValue();

    let file = await outgoingInvoiceApi.getSettingsLogo();
    if (!!file?.data?.size) {
      this.logo = URL.createObjectURL(file.data);
    } else {
      this.logo = '';
    }
  }

  get currentGlobalIncNo() {
    return (this.editModel.currentIncrementValue ?? 0) + 1;
  }

  set currentGlobalIncNo(no: number) {
    this.editModel.currentIncrementValue = no - 1;
  }

  get prefix() {
    let datePrefix = '';
    if (this.editModel.prefixDateFormat) {
      datePrefix = UserStore.userNowDateTime.toFormat(this.editModel.prefixDateFormat);
    }

    return (this.editModel.prefix ?? '') + datePrefix;
  }

  async loadCurrentLocalIncrementValue() {
    if (!this.editModel.useGlobalIncrementValue) {
      this.localCurrentIncrementValue = await outgoingInvoiceApi.getCurrentLocalIncrementValue(this.prefix);
    }
  }

  get prefixDateFormatOptions() {
    return [
      { value: null as any, description: this.$t('Kein Datums-Prefix') },
      { value: 'yyyyMMdd', description: '20230101 - yyyyMMdd' },
      { value: 'yyyy-MM-dd', description: '2023-01-01 - yyyy-MM-dd' },
      { value: 'yyyyMM', description: '202301 - yyyyMM' },
      { value: 'yy-MM', description: '23-01 - yy-MM' },
      { value: 'yyyy', description: '2023 - yyyy' },
    ];
  }

  get invoiceNoPreview() {
    let invoiceNo = this.editModel.prefix ?? '';

    if (this.editModel.prefixDateFormat) {
      invoiceNo += UserStore.userNowDateTime.toFormat(this.editModel.prefixDateFormat);
    }

    let incrementVal = '1';

    if (this.editModel.useGlobalIncrementValue) {
      incrementVal = this.currentGlobalIncNo?.toString() ?? '1';
    } else {
      incrementVal = this.localCurrentIncrementValue.toString();
    }

    invoiceNo += incrementVal.padStart(this.editModel.incrementNoOfZerosToPad ?? 0, '0');

    return invoiceNo;
  }

  get countries(): any[] {
    const countries = [
      {
        value: 'DE',
        description: 'Deutschland',
      },
      {
        value: 'AT',
        description: 'Österreich',
      },
      {
        value: 'CH',
        description: 'Schweiz',
      }
      ,
      {
        value: 'NL',
        description: 'Niederlande',
      }
      ,
      {
        value: 'BE',
        description: 'Belgien',
      }
      ,
      {
        value: 'FR',
        description: 'Frankreich',
      }
      ,
      {
        value: 'DK',
        description: 'Dänemark',
      }
    ];
    return countries;
  }

  async deleteLogo() {
    try {
      this.loadingOverlay = true;
      await outgoingInvoiceApi.deleteLogo();
      await this.loadData();
    } finally {
      this.loadingOverlay = false;
    }
  }

  openFileSelect() {
    (this.$refs.file as HTMLInputElement).click();
  }

  async upload() {
    try {
      this.loadingOverlay = true;
      this.$emit('loadStart');
      //@ts-ignore
      if (!(this.$refs.file as HTMLInputElement).files[0]) {
        return;
      }
      //@ts-ignore
      const fileData = (this.$refs.file as HTMLInputElement).files[0] as any;
      await outgoingInvoiceApi.uploadLogo({ data: fileData, fileName: fileData.name });
      await this.loadData();
    } finally {
      this.loadingOverlay = false;
      this.$emit('loadEnd');
    }
  }

  async submitInvoice() {
    try {
      this.loading = true;
      await outgoingInvoiceApi.updateSettings(this.editModel);
      notifySuccess('Gespeichert');
    } finally {
      this.loading = false;
    }
  }
}
